import styled, { css } from 'styled-components';

import Plus from './icons/Plus';
import Minus from './icons/Minus';
import Bin from './icons/Bin';

export const Wrap = styled.div`
    display: flex;
    align-items: center;
`;

export const Quantity = styled.p`
    width: 8px;
    margin: 0 8px;
    ${({ theme }) => css(theme.typography.TinyParagraph)}
    color: ${({ theme }) => theme.colors['Level 5']};
`;

export const Button = styled.button`
    height: 20px;
    width: 20px;
    justify-content: center;
    align-items: center;
    &:hover {
        cursor: pointer;
    }
`;

export const Increase = styled(Plus)``;

export const Decrease = styled(Minus)``;

export const Remove = styled(Bin)``;
